<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="$apollo.loading"
    :items-per-page-options="[10, 25, 50, 100]"
    :search="search"
    v-bind="pagingOptions"
    :hide-default-footer="hideFooter"
    show-select
    v-model="selected"
  >
    <template v-slot:item.itineraryBookedBy="{ item }">
      {{ item.itinerary ? item.itinerary.bookedByName : "" }}
    </template>

    <template v-slot:item.exportedAt="{ item }">{{
      item.exportedAt | formatDate
    }}</template>
    <template v-slot:item.createdAt="{ item }">{{
      item.createdAt | formatDate
    }}</template>
    <template v-slot:item.itineraryStartDate="{ item }">{{
      item.itineraryStartDate | formatDate
    }}</template>
    <template v-slot:item.lodgementDate="{ item }">{{
      item.lodgementDate | formatDate
    }}</template>
    <template v-slot:item.paymentDate="{ item }">{{
      item.paymentDate | formatDate
    }}</template>
    <template v-slot:item.serviceStartDate="{ item }">
      {{
        item.invoice && item.invoice.firstServiceStartDate
          ? item.invoice.firstServiceStartDate
          : "" | formatDate
      }}
    </template>
    <template v-slot:item.supplierPayeeName="{ item }">
      {{
        item.invoice && item.invoice.supplier
          ? item.invoice.supplier.payeeName
          : ""
      }}
    </template>
    <template v-slot:item.supplierEmail="{ item }">
      {{
        item.invoice && item.invoice.supplier ? item.invoice.supplier.email : ""
      }}</template
    >
    <template v-slot:item.accountsEmail="{ item }">
      {{
        item.invoice && item.invoice.supplier
          ? item.invoice.supplier.accountsEmail
          : ""
      }}</template
    >
    <template v-slot:item.actions="{ item }">
      <default-list-actions
        :item="item"
        :hide-view="true"
        :hide-remove="
          $store.getters.hasAccessTo('finances:pi_payments_view_only') ||
          !$store.getters.hasAccessTo('finances:delete')
        "
        @deleteItem="deleteItem($event)"
        @editItem="editItem($event)"
      ></default-list-actions>
    </template>
    <template v-slot:item.itineraryReference="{ item }">
      <reference-label
        v-model="item.itineraryReference"
        :itinerary-id="item.itinerary ? item.itinerary.id : ''"
        new-tab
      ></reference-label>
    </template>

    <template v-slot:footer>
      <v-speed-dial
        v-if="selected.length > 0 && $store.getters.hasAccessTo('finances:xero_export')"
        v-model="fab"
        direction="right"
        absolute
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab">mdi-close</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-btn fab dark small color="blue" @click="exportToXero">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-export</v-icon>
            </template>
            Export Selected Records to Xero
          </v-tooltip>
        </v-btn>
      </v-speed-dial>

      <v-layout justify-space-around>
        <span>
          Total:
          <strong>{{ totalPrice }}</strong>
        </span>
      </v-layout>
    </template>
  </v-data-table>
</template>

<script>
import DefaultListActions from "../../shared/DefaultListActions";
import ReferenceLabel from "../../shared/labels/ReferenceLabel";
import { pagingOptions } from "../../../../helpers/index";
export default {
  name: "pi-payments-table",
  props: {
    headers: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
    search: {
      type: String,
      default: () => "",
    },
    hideFooter: {
      type: Boolean,
      defaultd: () => false,
    },
  },

  components: { DefaultListActions, ReferenceLabel },

  data() {
    return {
      pagingOptions,
      selected: [],
      fab: true,
    };
  },

  computed: {
    totalPrice() {
      let total = 0;
      if (this.items.length > 0) {
        total = this.items.reduce(
          (t, item) => Number(t) + Number(item.amount),
          total
        );
      }
      return total.toFixed(2);
    },
  },

  methods: {
    deleteItem(payload) {
      this.$emit("delete", payload);
    },
    editItem(payload) {
      this.$emit("edit", payload);
    },
    exportToXero() {
      this.$emit("export-to-xero", this.selected);
      this.selected = [];
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/finances/purchase-invoice-payments/PiPaymentsTable.vue